import ReportTypes from "./Types/ReportTypes";
import styles from './ScheduledReports.module.scss'
import { useEffect, useState } from "react";
import api from "helpers/api";
import { FaCheckCircle } from "react-icons/fa";
import {setAlert} from "store/alerts-slice";
import { useDispatch } from "react-redux";
import HasPermission from "../../helpers/permissions/HasPermission";

const ScheduledReports = ({userType}) => {
    const dispatch = useDispatch();
    const [isLoaded, setIsLoaded] = useState(false);
    const [preferences, setPreferences] = useState({});

    const options = [
        'never',
        'weekly',
        'monthly',
        'quarterly',
    ]

    useEffect(() => {
        getPrefernces();
    }, [])

    useEffect(() => {
        // Save preferences
        if(isLoaded) {
            updatePrefernces();
        }
    }, [preferences])

    const getReportTypes = () => {
        return ReportTypes.filter((report) => {
            let permitted = true;

            if (report.minUserRole !== undefined) {
                permitted = userType >= report.minUserRole;
            } else if (report.userRole !== undefined) {
                if(Array.isArray(report.userRole)) {
                    permitted = report.userRole.includes(userType);
                } else {
                    permitted = userType === report.userRole;
                }
            }

            return permitted;
        })
    }


    const getPrefernces = async () => {
        setIsLoaded(false)
        try {
            const res = await api.get('account/preferences');
            if(res.success && res.data.success) {
                setPreferences(res.data.data.scheduled_reports !== undefined ? res.data.data.scheduled_reports : {});
            }
        } catch(e) {

        } finally {
            setIsLoaded(true);
        }
    }


    const updatePrefernces = async() => {
        //setIsLoaded(false)
        try {
            const res = await api.patch('account/preferences', {
                preferences: {
                    scheduled_reports: preferences
                }
            });

            dispatch(setAlert({type: 'success'}))
        } catch(e) {

        } finally {
            //setIsLoaded(true);
        }

    }

    return (
        <div className={styles.reportTypes}>
            {getReportTypes().map((type, index) => {
                const isActive = preferences[type.id] !== undefined && preferences[type.id] !== 'never';

                return (
                    <div key={ index }  className={ `${styles.reportType}` }>
                        { type.icon }
                        <div>
                            <div className={ styles.reportTypeTitle }>{ type.title }</div>
                            <div className={ styles.reportTypeDescription }>{ type.description }</div>
                        </div>
                        <HasPermission permission="report.create">
                            <div className={styles['ms-auto']}>
                                {isLoaded && <div className="d-flex align-items-center">
                                    <span className={styles.reportActiveIcon}><FaCheckCircle style={{color: isActive ? '#00a699' : '#afb1b1'}} /></span>
                                    <select onChange={(e) => {
                                        const value = e.target.value;
                                        setPreferences({...preferences, [type.id]: value})
                                    }} defaultValue={preferences[type.id]} className={`alma-input ${styles.pointer}`}>
                                        {options.map((option, index) => {
                                            return (
                                                <option key={index} value={option}>{option.charAt(0).toUpperCase() + option.slice(1)}</option>
                                            )
                                        })}
                                    </select>
                                </div>}
                            </div>
                        </HasPermission>
                    </div>
                )
            })}
        </div>
    );
}

export default ScheduledReports;